module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"users":{"profile":{"portfolios":{"action":"Create portfolio","empty_state":"Create your own portfolios that you can share with other community members or use privately. With updates you will receive notifications so that you are always up to date.","title":"Portfolios"}}}}}}}')
  delete Component.options._Ctor
}
